import React from 'react'
import Moment from 'react-moment'
import { Link } from 'react-static'
import PropTypes from 'prop-types'

import BlogPostPreview from '../BlogPostPreview'

import hero from '../../images/home-blog-hero.jpg'

Moment.globalFormat = 'DD/MM/YY'

class HomeBlog extends React.Component {
  static propTypes = {
    posts: PropTypes.array.isRequired,
  }

  state = { loadHero: false }

  componentDidMount() {
    if (this.props.loaderHidden) {
      this.loadHero()
    }
  }

  componentWillReceiveProps(next) {
    if (next.loaderHidden && !this.props.loaderHidden) {
      this.loadHero()
    }
  }

  loadHero = () => {
    this.setState({ loadHero: true })
  }

  render() {
    const { posts, loaderHidden } = this.props
    const heroStyle = { background: `url(${hero}) no-repeat center center`, backgroundSize: 'cover' }
    const { loadHero } = this.state
    return (
      <div className="home-blog home-latest blog-wrapper">
        <div style={ loadHero ? heroStyle : null} className="home-blog__title">
          <h2>Latest News</h2>
        </div>
        <div className="blog-more relative">
          <div className="blog-more__content-wrapper">
            { posts !== null
              && posts.map((post, i) => (
                i < 2 &&
                <BlogPostPreview
                  key={i}
                  title={post.fields.title}
                  slug={post.fields.slug}
                  id={post.sys.id}
                  date={post.fields.date}
                  src={post.fields.featuredImage.fields.file.url}
                  town={post.location.town}
                  region={post.location.region}
                  loaderHidden={loaderHidden}
                />
              ))
            }
          </div>
        </div>
        <div className="blog-more__footer">
          <h5>Take a look at more of our recent work</h5>
          <Link to="/blog">
            <button className="secondary-button">View Blog</button>
          </Link>
        </div>
      </div>
    )
  }
}

export default HomeBlog



// WEBPACK FOOTER //
// /opt/build/repo/src/components/home-page/HomeBlog.js